export default __webpack_public_path__ + "static/media/fifa2-bg-cn.bdbdc75c.jpg";